import React from 'react'

function Question() {
  return (
    <div>
      question
    </div>
  )
}

export default Question
